import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import TableLayout from "../../../components/TableLayout";

import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import TableActions from "../../../components/Common/TableActions";
import Toggle from "../../../components/Common/Toggle";
import dataHandler from "../../../hooks/dataHandler";
import {
  CHANGE_NOTIFICATION_STATUS,
  CONTENT_DELETE,
  CONTENT_LIST,
  CONTENT_STATUS_CHANGE,
  DELETE_NOTIFICATION,
  LIST_NOTIFICATIONS,
} from "../../../services/ApiCalls";
import {
  activeInactiveOptions,
  typeOptionsArray,
} from "../../../utilities/const";
import moment from "moment";

const Notification = () => {
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
    statusChangeHandler,
  } = dataHandler({
    api: LIST_NOTIFICATIONS,
  });

  const column = [
    {
      head: "Notification ID",
      accessor: "srNo",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    { head: "Title", accessor: "title" },
    {
      head: "User Type",
      accessor: "",
      isComponent: true,
      component: (item, ind) => {
        return (
          <>
            {typeOptionsArray.map((opt) => {
              return opt.value === item.type ? opt.label : <></>;
            })}
          </>
        );
      },
    },
    {
      head: "Status",
      accessor: "",
      isComponent: true,
      component: (item, ind) => {
        return (
          <>
            <span className={item.status}>{item.status}</span>
          </>
        );
      },
    },
    {
      head: "Created At",
      accessor: "createdAt",
      classNames: "fw-sbold",
      isComponent: true,
      component: (item) => (
        <>{moment(item.date_created_utc).format("DD-MM-YYYY")}</>
      ),
    },
    {
      head: "Actions",
      accessor: "",
      isComponent: true,
      //
      component: (item) => (
        <TableActions
          editUrl={`/notification/edit/${item._id}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        confirmHandler={() =>
          deleteHandler(() => DELETE_NOTIFICATION({ _id: deleteModel.dumpId }))
        }
      />
      <section className="contentPage py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Notification Management
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left"></div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Link
                        to={"/notification/add"}
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Add New
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout loader={loader} data={data} column={column} />
              <CustomPagination
                body={body}
                pageChangeHandler={paginationHandler}
                setBody={setBody}
                total={total}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Notification;
//
